var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11172 0.663992C5.38641 -0.221336 6.61359 -0.221326 6.88828 0.663993L7.87863 3.85593H11.0679C11.5333 3.85593 11.8496 4.1766 11.9562 4.51993C12.0622 4.86184 11.9848 5.29639 11.6247 5.57038L9.02441 7.54884L10.0204 10.759C10.1518 11.1825 9.98274 11.5859 9.68896 11.8094C9.39164 12.0356 8.94404 12.09 8.57528 11.8094L6 9.84999L3.42472 11.8094C3.05596 12.09 2.60836 12.0356 2.31104 11.8094C2.01726 11.5859 1.84818 11.1825 1.9796 10.759L2.97559 7.54884L0.375284 5.57038C0.0151699 5.29638 -0.0622393 4.86184 0.0438467 4.51992C0.150371 4.17659 0.466696 3.85593 0.932124 3.85593H4.12137L5.11172 0.663992ZM6 1.27232L5.08528 4.2205C4.96656 4.60313 4.61626 4.8845 4.197 4.8845H1.17253L3.63953 6.76153C3.96375 7.00821 4.08866 7.43265 3.97097 7.81198L3.04117 10.8088L5.44316 8.98118C5.77351 8.72984 6.22649 8.72984 6.55684 8.98118L8.95883 10.8088L8.02903 7.81198C7.91134 7.43265 8.03625 7.00822 8.36047 6.76153L10.8275 4.8845H7.803C7.38374 4.8845 7.03344 4.60313 6.91472 4.2205L6 1.27232Z",
    fill: "#2BCFA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08528 4.2205L6 1.27232L6.91472 4.2205C7.03344 4.60313 7.38374 4.8845 7.803 4.8845H10.8275L8.36047 6.76153C8.03625 7.00822 7.91134 7.43265 8.02903 7.81198L8.95883 10.8088L6.55684 8.98118C6.22649 8.72984 5.77351 8.72984 5.44316 8.98118L3.04117 10.8088L3.97097 7.81198C4.08866 7.43265 3.96375 7.00821 3.63953 6.76153L1.17253 4.8845H4.197C4.61626 4.8845 4.96656 4.60313 5.08528 4.2205Z",
    fill: "#2BCFA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/starFilled.b54af7c318de18b48e01403b207e1608.svg";
export { ForwardRef as ReactComponent };